import karteCustonEventClient from '../common/karte/custom_event';

document.addEventListener('DOMContentLoaded', () => {
  const editDiv = document.getElementById('store_notifications_edit');
  if (editDiv == null) {
    return;
  }

  const sendKarteEvent = (event_name: string, content_name: string, message: string) => {
    // 更新したことをKARTEに通知
    karteCustonEventClient.sendEvent({
      event_name: event_name,
      content_name: content_name,
      message: message
    });
  }

  // 更新時に実行
  editDiv.addEventListener('submit', () => {
    // KARTEに登録イベントを送信
    sendKarteEvent(
      'update_content',
      'store_notifications',
      'お知らせを更新しました'
    );
  })
});
